import PropertyTreeNode from '../Node/PropertyTreeNode'

export const PropertyTreeEmptyNode = ({ ...props }) => {
  return <PropertyTreeNode {...props} />
}
export default PropertyTreeEmptyNode
